// src/components/InlineSvg.jsx
import React, { useState, useEffect } from 'react';

function InlineSvg({ src, className = '', fallback = './assets/placeholder.svg', alt = '' }) {
  const [svgContent, setSvgContent] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    // Если src отсутствует или не оканчивается на .svg — считаем это ошибкой / Wenn src fehlt oder nicht auf .svg endet, wird dies als Fehler betrachtet.
    if (!src || !src.endsWith('.svg')) {
      setError(true);
      return;
    }

    fetch(src)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Fehler beim Laden ${src}: ${res.status}`);
        }
        return res.text();
      })
      .then((text) => {
        setSvgContent(text);
      })
      .catch((err) => {
        console.error(err);
        setError(true);
      });
  }, [src]);

  // Если ошибка или контента пока нет -> fallback / Falls ein Fehler auftritt oder der Inhalt noch nicht vorhanden ist -> Fallback verwenden.
  if (error || !svgContent) {
    return (
      <img
        src={fallback}
        alt={alt}
        className={className}
        style={{ width: 'auto', height: 'auto' }}
      />
    );
  }

  // Вставляем контент SVG как HTML, чтобы стили могли его «видеть» / Einfügen des SVG-Inhalts als HTML, damit die Styles darauf zugreifen können.
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: svgContent }}
      aria-label={alt} // для доступности / Für Barrierefreiheit.
    />
  );
}

export default InlineSvg;
